import { h, Component } from 'preact';

export default class CountingDown extends Component {
    constructor(props) {
        super(props);
        this.timeoutInterval = null;
        this.state = {
            minutes: '',
            seconds: ''
        }
    }

    componentDidMount() {
        let timeout = this.props.timeout;
        this.setFormattedTime(timeout);
        this.timeoutInterval = setInterval(() => {
            timeout--;
            this.setFormattedTime(timeout);
            if (timeout < 0) {
                this.props.action();
            }
        }, 1000);
    }

    setFormattedTime = timeout => {
        if (this.props.ssItem) {
            sessionStorage.setItem(this.props.ssItem, timeout);
        }
        const minutes = Math.floor((~~timeout) / 60);
        const seconds = Math.floor((~~timeout) % 60);
        this.setState({minutes, seconds});
    }

    componentWillUnmount() {
        if (this.props.ssItem) {
            sessionStorage.removeItem(this.props.ssItem);
        }
        clearInterval(this.timeoutInterval);
        this.timeoutInterval = null;
    }

    render({}, {minutes, seconds}) {
        return(
            <span class='counting-down'>
                {minutes} min {seconds} sec
            </span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scripts/views/tags/counting-down.js